import React, { lazy } from 'react';
import { RouteObject, Outlet } from 'react-router-dom';

const AcgrDashboardPage = lazy(() => import('./pages/home/AcgrDashboardPage'));
const PlaybooksPage = lazy(() => import('./pages/playbooks/PlaybookPage'));
const TrafficDistributionGroups = lazy(() => import('./pages/trafficDistributionGroups/TrafficDistributionGroupsPage'));
const TrafficDistributionGroupDetailPage = lazy(
  () => import('./pages/trafficDistributionGroups/DetailPage/TrafficDistributionGroupDetailPage')
);

export const ACGR_ROUTES = {
  DASHBOARD: '/portal/acgr/dashboard',
  PLAYBOOKS: '/portal/acgr/playbooks',
  TRAFFIC_DISTRIBUTION_GROUPS: '/portal/acgr/traffic-distribution-groups',
  TRAFFIC_DISTRIBUTION_GROUPS_ITEM: '/portal/acgr/traffic-distribution-groups/:trafficDistributionGroupId'
};

const routes: RouteObject[] = [
  {
    element: <Outlet />,
    children: [
      {
        path: ACGR_ROUTES.DASHBOARD,
        element: <AcgrDashboardPage />
      },
      {
        path: ACGR_ROUTES.PLAYBOOKS,
        element: <PlaybooksPage />
      },
      {
        path: ACGR_ROUTES.TRAFFIC_DISTRIBUTION_GROUPS,
        element: <TrafficDistributionGroups />
      },
      {
        path: ACGR_ROUTES.TRAFFIC_DISTRIBUTION_GROUPS_ITEM,
        element: <TrafficDistributionGroupDetailPage />
      }
    ]
  }
];

export default routes;
